import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: ['inverse'],
  states: []
}

export default function Shortcut(props) {
  const { icon, children, target, inverse, disabled, href, ...rest } = props

  return (
    <a
      {...rest}
      className={resolveProps(props, config, 'Shortcut')}
      href={href}
      target={target}
      disabled={disabled}
    >
      <span
        className={'mdn-Shortcut-icon mdn-Icon-' + icon + ' mdn-Icon--md'}
      ></span>
      <p className="mdn-Shortcut-text">{children}</p>
    </a>
  )
}

Shortcut.propTypes = {
  icon: PropTypes.string,
  inverse: PropTypes.bool,
  children: PropTypes.node,
  config: PropTypes.object,
  disabled: PropTypes.bool,
  href: PropTypes.string
}
